var _rect, _path, _path2, _path3, _rect2, _circle, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgToolsFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 130,
    viewBox: "0 0 159 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.8579,
    y: 25.0339,
    width: 57.1705,
    height: 69.081,
    rx: 6.35227,
    fill: "#E4EAF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5348 81.1203C52.9984 79.1657 51.7869 77.2064 49.8307 76.7443C47.8761 76.2822 45.9152 77.4937 45.4547 79.4499C44.9927 81.4045 46.2042 83.3639 48.1604 83.8259C50.1149 84.288 52.0743 83.0765 52.5348 81.1203Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3507 82.8577C63.7702 81.4366 63.7702 79.1343 62.3507 77.7132C60.9296 76.2937 58.6257 76.2937 57.2046 77.7132C55.7835 79.1343 55.7835 81.4366 57.2046 82.8577C58.6257 84.2788 60.9296 84.2788 62.3507 82.8577Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0072 82.8577C74.4267 81.4366 74.4267 79.1343 73.0072 77.7132C71.5861 76.2937 69.2822 76.2937 67.8611 77.7132C66.44 79.1343 66.44 81.4366 67.8611 82.8577C69.2822 84.2788 71.5861 84.2788 73.0072 82.8577Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 43.7684,
    y: 33.7683,
    width: 31.7614,
    height: 18.5275,
    rx: 9.26373,
    fill: "#A4B1C0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53.0321,
    cy: 43.0321,
    r: 6.61695,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9072 116.171C77.7719 116.168 76.6843 115.717 75.8808 114.916C75.0774 114.112 74.6265 113.023 74.6249 111.889V76.0729C74.6249 74.9376 75.0758 73.8468 75.8792 73.0433C76.6811 72.2383 77.7703 71.7858 78.9072 71.7826H109.56C110.697 71.7858 111.786 72.2383 112.589 73.0433C113.391 73.8468 113.842 74.9376 113.842 76.0729V111.889C113.841 113.023 113.39 114.112 112.586 114.916C111.784 115.717 110.695 116.168 109.56 116.171H78.9072Z",
    fill: "#D0D9E2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.991 105.065C87.4546 103.11 86.2431 101.151 84.2869 100.689C82.3323 100.227 80.3714 101.438 79.9109 103.394C79.4488 105.349 80.6603 107.308 82.6165 107.77C84.5711 108.232 86.5305 107.021 86.991 105.065Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8065 106.802C98.226 105.381 98.226 103.078 96.8065 101.657C95.3854 100.238 93.0815 100.238 91.6604 101.657C90.2393 103.078 90.2393 105.381 91.6604 106.802C93.0815 108.223 95.3854 108.223 96.8065 106.802Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M108.564 105.065C109.028 103.11 107.816 101.151 105.86 100.689C103.905 100.227 101.946 101.438 101.484 103.394C101.022 105.349 102.233 107.308 104.19 107.77C106.144 108.232 108.103 107.021 108.564 105.065Z",
    fill: "#064AD3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M104.707 105.774V102.862H105.633C105.731 102.862 105.83 102.881 105.92 102.918C106.011 102.956 106.093 103.011 106.163 103.081C106.233 103.151 106.289 103.234 106.327 103.324C106.365 103.416 106.384 103.513 106.384 103.612C106.384 103.71 106.365 103.807 106.327 103.899C106.289 103.99 106.233 104.072 106.163 104.142C106.093 104.212 106.011 104.267 105.92 104.304C105.83 104.342 105.731 104.361 105.633 104.361H104.177",
    stroke: "black",
    strokeWidth: 0.635125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M104.177 105.103H105.325",
    stroke: "black",
    strokeWidth: 0.635125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3362 92.3286C80.1949 92.3286 80.06 92.273 79.9599 92.173C79.8599 92.073 79.8043 91.938 79.8043 91.7967C79.8043 91.6554 79.8599 91.5204 79.9599 91.4204C80.06 91.3219 80.1949 91.2648 80.3362 91.2648H108.131C108.272 91.2648 108.407 91.3219 108.507 91.4204C108.607 91.5204 108.663 91.6554 108.663 91.7967C108.663 91.938 108.607 92.073 108.507 92.173C108.407 92.273 108.272 92.3286 108.131 92.3286H80.3362Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6244 94.2531C94.9661 94.2531 96.0538 93.1654 96.0538 91.8237C96.0538 90.482 94.9661 89.3944 93.6244 89.3944C92.2843 89.3944 91.1951 90.482 91.1951 91.8237C91.1951 93.1654 92.2843 94.2531 93.6244 94.2531Z",
    fill: "#7698DD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3712 81.3444C80.2314 81.3444 80.0965 81.2873 79.9948 81.1872C79.8948 81.0888 79.8392 80.9522 79.8392 80.8125C79.8392 80.6712 79.8948 80.5362 79.9948 80.4362C80.0965 80.3362 80.2314 80.279 80.3712 80.279H108.166C108.307 80.279 108.442 80.3362 108.542 80.4362C108.642 80.5362 108.698 80.6712 108.698 80.8125C108.698 80.9522 108.642 81.0888 108.542 81.1872C108.442 81.2873 108.307 81.3444 108.166 81.3444H80.3712Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M101.487 83.2224C102.827 83.2224 103.915 82.1348 103.915 80.7931C103.915 79.453 102.827 78.3653 101.487 78.3653C100.144 78.3653 99.0579 79.453 99.0579 80.7931C99.0579 82.1348 100.144 83.2224 101.487 83.2224Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M116.816 30.0832C106.729 30.0832 110.354 55.4151 101.675 55.4151C95.0888 55.4151 97.4292 36.96 88.7502 36.96C72.2005 36.96 77.8563 16.1628 60.6841 16.1628",
    stroke: "black",
    strokeWidth: 0.635125,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M116.921 33.5208C115.02 33.5208 113.482 31.9823 113.482 30.0832C113.482 28.1826 115.02 26.644 116.921 26.644C118.82 26.644 120.359 28.1826 120.359 30.0832C120.359 31.9823 118.82 33.5208 116.921 33.5208Z",
    fill: "#6195FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7705 40.377C86.8715 40.377 85.3329 38.8385 85.3329 36.9394C85.3329 35.0388 86.8715 33.5002 88.7705 33.5002C90.6711 33.5002 92.2097 35.0388 92.2097 36.9394C92.2097 38.8385 90.6711 40.377 88.7705 40.377Z",
    fill: "#A0CFFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7046 19.5815C58.8056 19.5815 57.267 18.0429 57.267 16.1423C57.267 14.2433 58.8056 12.7047 60.7046 12.7047C62.6036 12.7047 64.1438 14.2433 64.1438 16.1423C64.1438 18.0429 62.6036 19.5815 60.7046 19.5815Z",
    fill: "#064AD3"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolsFooter);
export default __webpack_public_path__ + "static/media/toolsFooter.5d0036ab06856a832d396e370addcb69.svg";
export { ForwardRef as ReactComponent };